<template>
  <div>
    <div class="container-fluid">
      <div class="row bg-blue-200">
        <div class="col-12 text-center mb-4">
          <h3>Votre transaction a bien été enregistrée</h3>
        </div>
      </div>
    </div>
    <div
      class="container-fluid"
      style="margin-top: -20px"
    >
      <div class="row">
        <div class="col-12 text-center mb-3">
          <img
            class="img-fluid"
            style="height: 250px"
            :src="aws + '/unicorn-party.png'"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="container">
            <div class="d-flex flex-column text-center">
              <p class="font-weight-bold">
                Veuillez patienter pendant la génération de vos documents :
              </p>
              <p v-if="seconds > 0">
                <br>
                <span class="fw-bold">
                  {{ seconds }} seconde{{ seconds > 1 ? 's' : '' }}
                </span>
                <br>
              </p>
              <div v-else>
                <div class="mt-3">
                  Redirection en cours
                  <span class="loader__dot">.</span>
                  <span class="loader__dot">.</span>
                  <span class="loader__dot">.</span>
                </div>
                <div
                  class="spinner-border text-primary mx-auto my-3"
                  style="width: 2rem;
                height: 2rem;
                border-width: thin;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { routing } from '@/mixins';

export default {
  name: 'ConfirmationView',
  mixins: [routing],
  data() {
    return {
      path: 'https://app.assurup.com/login',
      counter: 0,
      seconds: 15,
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    ready() { return this.seconds === 0 },
  },
  mounted() {
    this.counter = setInterval(() => {
      this.seconds -= 1;
      if (this.seconds === -1) {
        this.replaceRoute();
      }
    }, 1000);
  },
  methods: {
    async replaceRoute() {
      await this.$router.replace('/client');
      this.$router.go(0);
    },
  },
};
</script>
<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
</style>
